import { Tooltip } from 'antd';
import { Link, Copy } from 'lucide-react';
import { useTranslate } from '@tolgee/react';
import { useCopyText } from 'hooks/useCopyText';
import { cx } from '@emotion/css';
import { openExternalURL } from 'utils/openExternalURL';
import { getPopupContainer } from 'components/LightConversation/utils/popover';

interface ProductInfoTitleProps {
  title: string;
  url?: string;
  className?: string;
  copyable?: boolean;
}

export const ProductInfoTitle = (props: ProductInfoTitleProps) => {
  const { title, url, className, copyable = true } = props;
  const { t } = useTranslate();
  const copyText = useCopyText();

  return (
    <div className={cx('group flex items-center gap-2 cursor-pointer', className)}>
      <div
        className="truncate font-medium text-[#232426] transition-colors group-hover:text-[#336FFF]"
        title={title}
        onClick={(e) => {
          e.stopPropagation();
          if (url) {
            openExternalURL(url, '__blank');
          }
        }}
      >
        {title}
      </div>
      <div className="items-center hidden gap-2 group-hover:flex flex-shrink-0">
        {url && copyable ? (
          <Tooltip title={t('复制链接')} getPopupContainer={getPopupContainer}>
            <span
              className="inline-flex cursor-pointer text-[#464D5A]"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                copyText(url);
              }}
            >
              <Link size={16} />
            </span>
          </Tooltip>
        ) : null}
        {copyable ? (
          <Tooltip title={t('复制')} getPopupContainer={getPopupContainer}>
            <span
              className="inline-flex cursor-pointer text-[#464D5A]"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                copyText(title);
              }}
            >
              <Copy size={16} />
            </span>
          </Tooltip>
        ) : null}
      </div>
    </div>
  );
};
